import Drawer from '@/component/Drawer'
import Modal from '@/component/Modal'
import useRuntime from '@/hook/useRuntime'
import useStatePopup from '@/hook/useStatePopup'
import { PopupSelector, PopUpStore } from '@/store/PopupStore'
import React from 'react'
import { useTranslation } from 'react-i18next'
import PayMain from './PayMain'

const PayPopup: React.FC<PropType> = () => {
  const { t } = useTranslation('wallet')
  const { client } = useRuntime()
  const { visible } = useStatePopup(PopupSelector.payPopup)

  const handleClose = () => {
    PopUpStore.setPayPopup({
      visible: false
    })
  }

  if (client === 'mobile') {
    return (
      <Drawer
        visible={visible}
        placement="bottom"
        height={667}
        zIndex={910}
        onClose={handleClose}
        lockScroll={true}
        destroyOnClose
        className="bg-white"
        title={t('modalTitle.pay')}
      >
        <PayMain />
      </Drawer>
    )
  }

  return (
    <Modal
      visible={visible}
      zIndex={910}
      width={680}
      destroyOnClose
      onCancel={handleClose}
      footer={null}
      icon={false}
      closable
      title={t('modalTitle.pay')}
    >
      <PayMain />
    </Modal>
  )
}

interface PropType {}

export default PayPopup
